import { create } from 'zustand'
import liveAuctionData from '../assets/fake-data/data-live-auction'
import heroSliderData from '../assets/fake-data/data-slider'
import todayPickData from '../assets/fake-data/data-today-pick'
import popularCollectionData from '../assets/fake-data/data-popular-collection'
import itemService from '../services/itemService'

const useHomeStore = create((set) => ({
    sliders: [],
    popularItems: [],
    newItems: [],
    bundles: [],
    loading: false,
    error: null,

    fetchHeroSliderData: async () => {
        set({ loading: true, error: null })
        try {
            // const response = await itemService.getItems()
            // set({ items: response.data, loading: false })
            const sliders = heroSliderData
            set({ sliders, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
    fetchPopularItems: async () => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItems()
            set({ popularItems: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
    fetchNewItems: async () => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItems()
            set({ newItems: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
    fetchBundles: async () => {
        set({ loading: true, error: null })
        try {
            // const response = await itemService.getItems()
            // set({ items: response.data, loading: false })
            const bundles = popularCollectionData
            set({ bundles, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
}))

export default useHomeStore
